import { appAlert } from "./appDialogs";
import { API_ORIGIN, apiUrl } from "./apiOrigin";
import React, { useState, useRef } from "react";
import './Login.css';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Input, InputLabel } from "@mui/material";
const Login = ({
  setToken,
  setUserData
}) => {
  const [email, setemail] = useState("");
  const [password, setPassword] = useState("");
  const emailInput = useRef(null);
  const passwordInput = useRef(null);
  const [createOpen, setCreateOpen] = useState(false);
  const [newOrgName, setNewOrgName] = useState("");
  const [newemail, setNewemail] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const _getallpharmacies = async token => {
    try {
      const response = await fetch(apiUrl("/getallpharmacies"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        }
      });
      const data = await response.json();
      if (!Array.isArray(data.pharmacies)) throw new Error("Invalid pharmacy list");
      localStorage.setItem("members", JSON.stringify(data.pharmacies));
      console.log("✅ Pharmacies updated");
    } catch (err) {
      console.error("❌ Failed to fetch pharmacies:", err);
      (await appAlert("Could not fetch pharmacy list."));
    }
  };
  const handleLogin = async () => {
    // Password managers can fill the DOM without firing React's onChange.
    // Submit exactly what is displayed; never trim or transform a password.
    const enteredEmail = emailInput.current?.value ?? email;
    const enteredPassword = passwordInput.current?.value ?? password;
    if (!enteredEmail || !enteredPassword) {
      (await appAlert("Please enter your login and password."));
      return;
    }
    try {
      const response = await fetch(apiUrl("/api/login"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          email: enteredEmail,
          password: enteredPassword
        })
      });
      let data;
      try {
        data = await response.json();
      } catch (jsonErr) {
        const raw = await response.text();
        console.error("❌ Failed to parse JSON. Raw response:", raw);
        (await appAlert("Server returned an invalid response."));
        return;
      }
      if (response.ok) {
        const token = data.token;
        if (token) {
          localStorage.setItem("authToken", token);
        }
        localStorage.setItem("userId", data._id);
        localStorage.setItem("organisationName", data.organisation_name);
        localStorage.setItem("expireBefore", data.expireBefore);
        localStorage.setItem("slowBefore", data.slowBefore);
        localStorage.setItem("scanToShelf", data.scanToShelf !== false);
        localStorage.setItem("inventory", data.inventory !== false);
        localStorage.setItem("housekeeping", data.housekeeping !== false);
        localStorage.setItem("activities", data.activities !== false);
        localStorage.setItem("communications", data.communications !== false);
        // ⬇️ new timesheet settings
        localStorage.setItem("send_timesheets", data.send_timesheets === true);
        localStorage.setItem("timesheet_day", data.timesheet_day ? parseInt(data.timesheet_day) : 1);
        if ('payroll_month_end' in data) {
          localStorage.setItem("payroll_month_end", data.payroll_month_end != null ? String(data.payroll_month_end) : "");
        }
        // NEW: persist manager email & SIM activity report flag
        if ('manager_email' in data) {
          localStorage.setItem("manager_email", data.manager_email || "");
        }
        ["report_sim", "report_expiring", "report_slow", "report_fridge"].forEach(k => {
          if (k in data) {
            localStorage.setItem(k, JSON.stringify(!!data[k]));
          }
        });

        // Optional modules (currently: Clinical record). Written only when the API
        // actually returns the key, so an older API build cannot silently switch a
        // module off for an organisation that has it enabled.
        ["clinical_record"].forEach(k => {
          if (k in data) {
            localStorage.setItem(k, JSON.stringify(!!data[k]));
          }
        });
        if (Array.isArray(data.members)) {
          const adjustedMembers = data.members.map(member => {
            if (member.openingTimes) return member;
            return {
              ...member,
              openingTimes: {
                Monday: {
                  open: "09:00",
                  close: "18:00"
                },
                Tuesday: {
                  open: "09:00",
                  close: "18:00"
                },
                Wednesday: {
                  open: "09:00",
                  close: "18:00"
                },
                Thursday: {
                  open: "09:00",
                  close: "18:00"
                },
                Friday: {
                  open: "09:00",
                  close: "18:00"
                },
                Saturday: {
                  open: "09:00",
                  close: "13:00"
                },
                Sunday: {
                  open: "00:00",
                  close: "00:00"
                }
              }
            };
          });
          localStorage.setItem("members", JSON.stringify(adjustedMembers));
        } else {
          localStorage.setItem("members", JSON.stringify([]));
        }
        if (setUserData) setUserData(data);
        if (setToken) setToken(token || "logged-in");
        const groupId = data._id;
        try {
          const shelvesResponse = await fetch(`${API_ORIGIN}/api/shelf_checks?groupId=${groupId}`, {
            headers: {
              "Authorization": `Bearer ${token}`
            }
          });
          const shelvesData = await shelvesResponse.json();
          const activeShelves = shelvesData.filter(shelf => shelf.active === true);
          localStorage.setItem("shelf_checks", JSON.stringify(activeShelves));
          console.log("✅ Shelf checks loaded and stored");
        } catch (err) {
          console.error("❌ Failed to load shelf checks:", err);
        }
        if (data.organisation_name === "Pharmace") {
          await _getallpharmacies(token);
        }
      } else {
        (await appAlert("Login failed. Please check your credentials."));
      }
    } catch (error) {
      console.error("🌐 Network or fetch error:", error.message);
      (await appAlert("Could not connect to the server."));
    }
  };
  const handleCreateGroup = async () => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await fetch(apiUrl("/creategroup"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({
          organisation_name: newOrgName,
          email: newemail,
          password: newPassword,
          expireBefore: 4,
          slowBefore: 26,
          members: [],
          scanToShelf: true,
          inventory: true,
          housekeeping: true,
          activities: true,
          communications: true
        })
      });
      if (!response.ok) {
        const msg = await response.text();
        throw new Error(msg);
      }
      (await appAlert("✅ Group created. You can now log in."));
      setCreateOpen(false);
    } catch (err) {
      console.error("❌ Error creating group:", err.message);
      (await appAlert("Failed to create group: " + err.message));
    }
  };
  const handleResetPassword = async () => {
    const email = emailInput.current?.value ?? "";
    if (!email) {
      (await appAlert("Please enter your email address (email) above first."));
      return;
    }
    try {
      const token = localStorage.getItem("authToken");
      const response = await fetch(apiUrl("/resetpassword"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({
          email
        })
      });
      if (response.ok) {
        (await appAlert("✅ Reset password link sent to your email address."));
      } else {
        (await appAlert("❌ Could not send reset password. Check your email address is correct."));
      }
    } catch (err) {
      console.error("Reset password error:", err);
      (await appAlert("Error sending reset password request."));
    }
  };
  return <div className="login-container">
      <h1 style={{
      textAlign: "center",
      marginBottom: "30px"
    }}>CQC Toolkit</h1>

      <div style={{
      display: "flex",
      justifyContent: "space-between",
      width: "100%"
    }}></div>

      <input ref={emailInput} name="email" autoComplete="username" type="text" className="login-input" placeholder="email" onChange={e => setemail(e.target.value)} />
      <input ref={passwordInput} name="password" autoComplete="current-password" type="password" className="login-input" placeholder="Password" onChange={e => setPassword(e.target.value)} />
      <button className="login-button" onClick={handleLogin}>Login</button>

      <p style={{
      textAlign: "center",
      marginTop: "10px"
    }}>
        <a href="#reset" onClick={e => {
        e.preventDefault();
        handleResetPassword();
      }}>
          Reset password
        </a>
      </p>

      <Dialog open={createOpen} onClose={() => setCreateOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Create New Group</DialogTitle>
        <DialogContent>
          <InputLabel>Organisation Name</InputLabel>
          <Input fullWidth value={newOrgName} onChange={e => setNewOrgName(e.target.value)} />
          <InputLabel sx={{
          marginTop: 2
        }}>email</InputLabel>
          <Input fullWidth value={newemail} onChange={e => setNewemail(e.target.value)} />
          <InputLabel sx={{
          marginTop: 2
        }}>Password</InputLabel>
          <Input fullWidth type="password" value={newPassword} onChange={e => setNewPassword(e.target.value)} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setCreateOpen(false)}>Cancel</Button>
          <Button onClick={handleCreateGroup} disabled={!newOrgName || !newemail || !newPassword}>
            Create
          </Button>
        </DialogActions>
      </Dialog>
    </div>;
};
export default Login;
